import { AngularFireUploadTask } from '@angular/fire/compat/storage';
import { UploadTaskSnapshot } from '@angular/fire/compat/storage/interfaces';
import { catchError, EMPTY, lastValueFrom, Observable } from 'rxjs';

import ValueObject from '../../../core/domain/value_object';
import { Transcription } from './transcription';

interface TranscriptionUploadProps {
  transcription: Transcription;
  task: AngularFireUploadTask;
}

export class TranscriptionUpload extends ValueObject<TranscriptionUploadProps> {
  get transcription(): Transcription {
    return this.props.transcription;
  }

  get task(): AngularFireUploadTask {
    return this.props.task;
  }

  get progress(): Observable<number | undefined> {
    return this.task.percentageChanges().pipe(
      catchError(() => {
        return EMPTY;
      }),
    );
  }

  get changes(): Observable<UploadTaskSnapshot | undefined> {
    return this.task.snapshotChanges();
  }

  cancel(): boolean {
    if (this.task.task.snapshot.state == 'canceled') return true;
    return this.task.cancel();
  }

  async finish(): Promise<any> {
    return lastValueFrom(this.changes);
  }

  private constructor(props: TranscriptionUploadProps) {
    super(props);
  }

  public static create(props: TranscriptionUploadProps): TranscriptionUpload {
    return new TranscriptionUpload(props);
  }
}
